import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import textAngular from 'textangular';
import textangularConfig from '../comment-section/textangular.decorator';
import StateChange from './state-change-modal.service';

export default angular
  .module('verifyApp.state-change-modal', [uiRouter, uiBootstrap, textAngular])
  .config(textangularConfig)
  .service('StateChangeService', StateChange)
  .name;



// WEBPACK FOOTER //
// ./client/components/state-change-modal/index.js